var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.842 6.578H.662v13.328h4.18V6.578ZM16.15 6.288c-.153-.019-.317-.028-.48-.038a4.877 4.877 0 0 0-4.123 1.887c-.125.164-.183.26-.183.26V6.616H7.368v13.328h4.179v-6.26c0-.905-.067-1.868.386-2.696.385-.693 1.078-1.04 1.858-1.04 2.311 0 2.36 2.09 2.36 2.282V20.002h4.18v-8.696c0-2.976-1.513-4.729-4.18-5.018ZM2.754 4.854a2.427 2.427 0 1 0 0-4.854 2.427 2.427 0 0 0 0 4.854Z",
    fill: "#E8E1F9"
  })));
};
export default SvgLinkedin;